export const DATE_FORMATS = {
    'DD-MM-YYYY': 'DD-MM-YYYY',
    'MM-DD-YYYY': 'MM-DD-YYYY',
    'YYYY-MM-DD': 'YYYY-MM-DD',
};
export const OPTION_CHILD_SEPARATOR = ',';
